module.exports = __webpack_public_path__ + "static/media/fachada.543b477d.jpg";